import { Component, OnInit } from '@angular/core';
import { Alerta } from 'src/app/models/alerta';
import { ShowModalService } from 'src/app/services/show-modal.service';

@Component({
  selector: 'app-confirmacao',
  templateUrl: './confirmacao.component.html',
  styleUrls: ['./confirmacao.component.scss']
})
export class ConfirmacaoComponent implements OnInit {

  public result: boolean = false
  public descricao:string = ""
  title: string = "";
  strongName: string = "";
  message: string = "";
  hideCancelButton: boolean = false;
  cancelLabel: string = "Cancelar";
  isDanger: boolean = false;
  confirmLabel: string = "Confirmar";

  showInputBox: boolean
  alerta: Alerta

  constructor(public showModalService: ShowModalService) { }

  ngOnInit() {
    this.alerta = new Alerta()
  }

  setAction(value: boolean) {
    if(value && this.descricao == "" && this.showInputBox){
      this.alerta.exibeMensagem("", 5)
      return
    }

    this.result = value
    this.showModalService.hide()
  }

  textChanged(value){
    this.descricao = value
  }

}
